import { Alert, Snackbar } from "@mui/material"
import { useAppSelector, useAppDispatch } from "../../app/hooks"
import { hideToast, selectToast } from "../../slices/toastSlice"

export function Toast(): JSX.Element {
  const toast = useAppSelector(selectToast)
  const dispatch = useAppDispatch()
  return (
    <Snackbar
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      open={toast.open}
      autoHideDuration={5000}
      onClose={() => dispatch(hideToast())}
    >
      <Alert
        onClose={() => dispatch(hideToast())}
        severity={
          toast.toastType === "success"
            ? "success"
            : toast.toastType === "error"
            ? "error"
            : toast.toastType === "info"
            ? "info"
            : "warning"
        }
        elevation={6}
        variant="filled"
      >
        {toast.msg}
      </Alert>
    </Snackbar>
  )
}

export default Toast
